import { promiseTimeout, whenever } from "@vueuse/core";
import { ref } from "vue";

const ONE_SECOND = 1000;
const ERROR_TIMEOUT = ONE_SECOND * 4;

const error = ref(null);

export function useState() {
  whenever(error, scheduleClearError);

  async function scheduleClearError() {
    await promiseTimeout(ERROR_TIMEOUT);
    clearError();
  }

  function setError(message) {
    error.value = message;
  }

  function clearError() {
    error.value = null;
  }

  return {
    error,

    setError,
    clearError,
  };
}
